/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import {
  StyledSection,
  StyledContentBlock,
  MainContainer,
  MainWrapper,
  FooterGrid,
  FooterColumn,
  ColumnTitle,
  StoreWrapper,
  GooglePlay,
  GooglePlayImageWrapper,
  AppStore,
  AppStoreImageWrapper,
  LinkList,
  LinkItem,
  StyledLink,
  DownWrapper,
  LogoContentWrapper,
  LogoImage,
  Copyright,
  CopyrightText,
  MobileWrapper,
  MobileDownloadSection,
  MobileLinkWrapper,
  MobileSectionSeparator,
  MobileSectionHeader,
  MobileSectionTitle,
  ToggleIcon,
  MobileSectionContent,
  MobileLinkList,
  MobileLinkItem,
  MobileLink,
  MobileFooterBottom,
  MobileLogoWrapper,
  MobileCopyright,
} from './styled';

const footerData = {
  links: [
    {
      message: 'Company',
      id: 'company',
      links: [
        {
          message: 'About Us',
          href: 'https://www.bitcoin.com/about-us/',
        },
        {
          message: 'Contact Us',
          href: 'https://www.bitcoin.com/contact-us/',
        },
        {
          message: 'Advertise',
          href: 'https://www.bitcoin.com/advertise/',
        },
        {
          message: 'Legal',
          href: 'https://www.bitcoin.com/legal/user-agreement/',
        },
        {
          message: 'Sitemap',
          href: 'https://www.bitcoin.com/sitemap/',
        },
      ],
    },
    {
      message: 'Insights',
      id: 'insights',
      links: [
        {
          message: 'News',
          href: 'https://news.bitcoin.com/',
        },
        {
          message: 'Markets',
          href: 'https://markets.bitcoin.com/',
        },
        {
          message: 'Expert Reviews',
          href: 'https://www.bitcoin.com/directory/',
        },
        {
          message: 'Learning Center',
          href: 'https://www.bitcoin.com/get-started/',
        },
      ],
    },
    {
      message: 'Products & Services',
      id: 'products',
      links: [
        {
          message: 'Bitcoin.com Account',
          href: 'https://accounts.bitcoin.com/',
        },
        {
          message: 'Bitcoin.com Wallet',
          href: 'https://wallet.bitcoin.com/',
        },
        {
          message: 'Buy Bitcoin',
          href: 'https://buy.bitcoin.com/',
        },
        {
          message: 'Verse DEX',
          href: 'https://verse.bitcoin.com/',
        },
      ],
    },
    {
      message: 'Reviews',
      id: 'reviews',
      links: [
        {
          message: 'Exchanges',
          href: 'https://www.bitcoin.com/exchanges/',
        },
        {
          message: 'Crypto Gambling',
          href: 'https://www.bitcoin.com/gambling/',
        },
        {
          message: 'Bitcoin Casinos',
          href: 'https://www.bitcoin.com/gambling/bitcoin-casino/',
        },
      ],
    },
    {
      message: 'Follow',
      id: 'follow',
      links: [
        {
          message: 'Telegram',
          href: 'https://t.me/GetVerse/1/',
        },
        {
          message: 'X',
          href: 'https://x.com/bitcoincom/',
        },
        {
          message: 'Discord',
          href: 'https://discord.com/invite/bitcoin-com/',
        },
        {
          message: 'LinkedIn',
          href: 'https://www.linkedin.com/company/bitcoin.com/',
        },
      ],
    },
  ],
  logo: {
    src: '/images/uploads/Bitcoin-logo.png',
    alt: 'Bitcoin.com Logo',
  },
  appstore: {
    src: '/images/uploads/footer-app-store.svg',
    alt: 'Appstore logo',
    link: 'https://apps.apple.com/us/app/bitcoin-com-wallet-buy-sell/id1252903728?ls=1',
  },
  playstore: {
    src: '/images/uploads/footer-google-play.svg',
    alt: 'Playstore logo',
    link: 'https://play.google.com/store/apps/details?id=com.bitcoin.mwallet&pli=1',
  },
  copyright: '© 2026 Saint Bitts LLC Bitcoin.com. All rights reserved',
};

const Footer = () => {
  const [expandedSection, setExpandedSection] = useState(null);

  const toggleSection = sectionId => {
    if (expandedSection === sectionId) {
      setExpandedSection(null);
    } else {
      setExpandedSection(sectionId);
    }
  };

  const findLinksById = id => {
    const found = footerData.links.find(item => item.id === id);
    return found ? found.links : [];
  };

  const findTitleById = id => {
    const found = footerData.links.find(item => item.id === id);
    return found ? found.message : '';
  };

  const mobileSections = [
    { id: 'company' },
    { id: 'insights' },
    { id: 'products' },
    { id: 'reviews' },
    { id: 'follow' },
  ];

  return (
    <StyledSection>
      <StyledContentBlock>
        <MainContainer>
          <MainWrapper>
            <FooterGrid>
              <FooterColumn>
                <ColumnTitle>Download App</ColumnTitle>
                <StoreWrapper>
                  <GooglePlay>
                    <a
                      href={footerData.playstore.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <GooglePlayImageWrapper>
                        <img
                          src={footerData.playstore.src}
                          alt={footerData.playstore.alt}
                        />
                      </GooglePlayImageWrapper>
                    </a>
                  </GooglePlay>
                  <AppStore>
                    <a
                      href={footerData.appstore.link}
                      target="_blank"
                      rel="noopener noreferrer"
                    >
                      <AppStoreImageWrapper>
                        <img
                          src={footerData.appstore.src}
                          alt={footerData.appstore.alt}
                        />
                      </AppStoreImageWrapper>
                    </a>
                  </AppStore>
                </StoreWrapper>
              </FooterColumn>
              <FooterColumn>
                <ColumnTitle>{findTitleById('company')}</ColumnTitle>
                <LinkList>
                  {findLinksById('company').map((link, linkIndex) => (
                    <LinkItem key={`company-${linkIndex}`}>
                      <StyledLink
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {link.message}
                      </StyledLink>
                    </LinkItem>
                  ))}
                </LinkList>
              </FooterColumn>
              <FooterColumn>
                <ColumnTitle>{findTitleById('insights')}</ColumnTitle>
                <LinkList>
                  {findLinksById('insights').map((link, linkIndex) => (
                    <LinkItem key={`insights-${linkIndex}`}>
                      <StyledLink
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {link.message}
                      </StyledLink>
                    </LinkItem>
                  ))}
                </LinkList>
              </FooterColumn>
              <FooterColumn>
                <ColumnTitle>{findTitleById('products')}</ColumnTitle>
                <LinkList>
                  {findLinksById('products').map((link, linkIndex) => (
                    <LinkItem key={`products-${linkIndex}`}>
                      <StyledLink
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {link.message}
                      </StyledLink>
                    </LinkItem>
                  ))}
                </LinkList>
              </FooterColumn>
              <FooterColumn>
                <ColumnTitle>{findTitleById('reviews')}</ColumnTitle>
                <LinkList>
                  {findLinksById('reviews').map((link, linkIndex) => (
                    <LinkItem key={`reviews-${linkIndex}`}>
                      <StyledLink
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {link.message}
                      </StyledLink>
                    </LinkItem>
                  ))}
                </LinkList>
              </FooterColumn>
              <FooterColumn>
                <ColumnTitle>{findTitleById('follow')}</ColumnTitle>
                <LinkList>
                  {findLinksById('follow').map((link, linkIndex) => (
                    <LinkItem key={`follow-${linkIndex}`}>
                      <StyledLink
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        {link.message}
                      </StyledLink>
                    </LinkItem>
                  ))}
                </LinkList>
              </FooterColumn>
            </FooterGrid>
            <DownWrapper>
              <LogoContentWrapper>
                <LogoImage
                  src={footerData.logo.src}
                  alt={footerData.logo.alt}
                />
              </LogoContentWrapper>
              <Copyright>
                <CopyrightText>{footerData.copyright}</CopyrightText>
              </Copyright>
            </DownWrapper>
          </MainWrapper>
          <MobileWrapper>
            <MobileDownloadSection>
              <ColumnTitle>Download App</ColumnTitle>
              <StoreWrapper>
                <GooglePlay>
                  <a
                    href={footerData.playstore.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <GooglePlayImageWrapper>
                      <img
                        src={footerData.playstore.src}
                        alt={footerData.playstore.alt}
                      />
                    </GooglePlayImageWrapper>
                  </a>
                </GooglePlay>
                <AppStore>
                  <a
                    href={footerData.appstore.link}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <AppStoreImageWrapper>
                      <img
                        src={footerData.appstore.src}
                        alt={footerData.appstore.alt}
                      />
                    </AppStoreImageWrapper>
                  </a>
                </AppStore>
              </StoreWrapper>
            </MobileDownloadSection>
            <MobileLinkWrapper>
              <MobileSectionSeparator />
              {mobileSections.map(section => (
                <React.Fragment key={section.id}>
                  <MobileSectionHeader
                    onClick={() => toggleSection(section.id)}
                  >
                    <MobileSectionTitle>
                      {findTitleById(section.id)}
                    </MobileSectionTitle>
                    <ToggleIcon>
                      {expandedSection === section.id ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="31"
                          height="31"
                          viewBox="0 0 31 31"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_6344_99941)">
                            <path
                              d="M15.6875 30.3477C23.9718 30.3477 30.6875 23.6319 30.6875 15.3477C30.6875 7.06338 23.9718 0.347656 15.6875 0.347656C7.40322 0.347656 0.6875 7.06338 0.6875 15.3477C0.6875 23.6319 7.40322 30.3477 15.6875 30.3477Z"
                              fill="#FF9500"
                            />
                            <path
                              d="M21 16.6049V15.0879H10V16.6049H21Z"
                              fill="black"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_6344_99941">
                              <rect
                                width="31"
                                height="30"
                                fill="white"
                                transform="translate(0 0.347656)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="31"
                          height="31"
                          viewBox="0 0 31 31"
                          fill="none"
                        >
                          <g clipPath="url(#clip0_6344_99941)">
                            <path
                              d="M15.6875 30.3477C23.9718 30.3477 30.6875 23.6319 30.6875 15.3477C30.6875 7.06338 23.9718 0.347656 15.6875 0.347656C7.40322 0.347656 0.6875 7.06338 0.6875 15.3477C0.6875 23.6319 7.40322 30.3477 15.6875 30.3477Z"
                              fill="#FF9500"
                            />
                            <path
                              d="M16.2592 10.3477H14.7422V21.3477H16.2592V10.3477Z"
                              fill="black"
                            />
                            <path
                              d="M21 16.6049V15.0879H10V16.6049H21Z"
                              fill="black"
                            />
                          </g>
                          <defs>
                            <clipPath id="clip0_6344_99941">
                              <rect
                                width="31"
                                height="30"
                                fill="white"
                                transform="translate(0 0.347656)"
                              />
                            </clipPath>
                          </defs>
                        </svg>
                      )}
                    </ToggleIcon>
                  </MobileSectionHeader>
                  <MobileSectionContent
                    isExpanded={expandedSection === section.id}
                  >
                    <MobileLinkList>
                      {findLinksById(section.id).map((link, linkIndex) => (
                        <MobileLinkItem
                          key={`mobile-${section.id}-${linkIndex}`}
                        >
                          <MobileLink
                            href={link.href}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {link.message}
                          </MobileLink>
                        </MobileLinkItem>
                      ))}
                    </MobileLinkList>
                  </MobileSectionContent>
                </React.Fragment>
              ))}
            </MobileLinkWrapper>
            <MobileFooterBottom>
              <MobileLogoWrapper>
                <LogoImage
                  src={footerData.logo.src}
                  alt={footerData.logo.alt}
                />
              </MobileLogoWrapper>
              <MobileCopyright>{footerData.copyright}</MobileCopyright>
            </MobileFooterBottom>
          </MobileWrapper>
        </MainContainer>
      </StyledContentBlock>
    </StyledSection>
  );
};

export default Footer;
